import { UserInfoDTO } from '../../../../gateway/PlatformBasicData'
import { Constants } from '../../../../model/common/Constants'
import moment from 'moment'
import { StudentUpdateRequest } from '../../../../gateway/BasicData-default'

/**
 * 用户信息
 */
class UserInfo {
  /**
   * 学员ID
   */
  userId: string

  /**
   * 姓名
   */
  name: string

  /**
   * 昵称
   */
  nickName: string

  /**
   * 唯一性类型,-1:未指定的唯一性标识,1:使用居民身份证作为用户唯一性标识
   */
  uniqueType: number

  /**
   * 唯一性值
   */
  uniqueData: string

  /**
   * 头像地址
   */
  displayPhotoUrl: string

  /**
   * 性别，1：男，2：女，3：中性，4：未知
   */
  sex: number

  /**
   * 出生年月
   */
  bornDay: Date

  /**
   * 手机号码
   */
  phoneNumber: string

  /**
   * 邮政编码
   */
  postCode: string

  /**
   * 所属地区编码
   */
  areaPath: string

  /**
   * 联系地址
   */
  address: string

  /**
   * 注册方式，11：平台注册，21：第三方互联之QQ，31：第三方互联之新浪微博，41：第三方互联之微信，42：第三方互联之 微信公众号，51：第三方互联之 外部来源
   */
  registerType: number

  /**
   * 注册来源，1：项目主网站，2：安卓，3：IOS 苹果
   */
  sourceType: number

  /**
   * 注册来源单位id
   */
  registerUnitId: string

  /**
   * 登陆账号
   */
  loginAccountNo: string
  /**
   * 工作单位
   */
  workUnitName: string
  /**
   * 工作单位地区路径
   */
  workUnitAreaPath: string
  /**
   * 判断是否登录
   */
  isLogin() {
    return !!this.userId
  }

  static from(dto: UserInfoDTO): UserInfo {
    const user = new UserInfo()
    user.userId = dto.userId
    user.name = dto.name
    user.nickName = dto.nickName
    user.uniqueType = dto.uniqueType
    user.phoneNumber = dto.phoneNumber
    user.uniqueData = dto.uniqueData
    user.displayPhotoUrl = dto.displayPhotoUrl
    user.sex = dto.sex
    if (dto.bornDay) {
      user.bornDay = moment(dto.bornDay, Constants.DATE_PATTERN).toDate()
    }
    user.phoneNumber = dto.phoneNumber
    user.postCode = dto.postCode
    user.areaPath = dto.areaPath
    user.address = dto.address
    user.registerType = dto.registerType
    user.sourceType = dto.sourceType
    user.registerUnitId = dto.registerUnitId
    user.workUnitName = dto.workUnitName
    user.workUnitAreaPath = dto.workUnitAreaPath
    return user
  }

  clone(): UserInfo {
    const user = new UserInfo()
    Object.assign(user, this)
    return user
  }

  toStudentUpdateDTO(): StudentUpdateRequest {
    const dto = new StudentUpdateRequest()
    dto.userId = this.userId
    dto.name = this.name
    dto.nickName = this.nickName
    dto.uniqueType = this.uniqueType
    dto.phoneNumber = this.phoneNumber
    dto.uniqueData = this.uniqueData
    dto.displayPhotoUrl = this.displayPhotoUrl
    dto.sex = this.sex
    if (this.bornDay) {
      dto.bornDay = moment(this.bornDay).format(Constants.DATE_PATTERN)
    }
    dto.postCode = this.postCode
    dto.areaPath = this.areaPath
    dto.address = this.address
    dto.registerType = this.registerType
    dto.sourceType = this.sourceType
    dto.registerUnitId = this.registerUnitId
    dto.workUnitName = this.workUnitName
    dto.workUnitAreaPath = this.workUnitAreaPath
    return dto
  }
}

export default UserInfo
